import CategoriesContainer from 'components/Categories/CategoriesContainer'
import CategoriesPresentation from 'components/Categories/CategoriesPresentation'
import CategoriesData from 'components/Categories/CategoriesData'

export default {
  Container: CategoriesContainer,
  Presentation: CategoriesPresentation,
  Data: CategoriesData,
}
